<template>
    <div>
        <appPage :is-show-header="false" class="overflow-y-auto min-h-100vh!">
            <div class="flex items-center relative">
                <div class="w-25px h-25px mr-5px flex items-center justify-center" @click="handleBack">
                    <img src="@/assets/images/mine/left.webp" class="w-full h-full" />
                </div>
                <!-- 搜索框 -->
                <div class="search-box flex items-center justify-between flex-1" @click="handleSearch"
                    ref="searchBoxRef">
                    <div class="flex items-center justify-center w-10px h-10px mr-5px">
                        <img src="@/assets/images/home/search.webp" class="w-full h-full" />
                    </div>
                    <input type="text" v-model="search" :placeholder="t('home.search')" class="flex-1 search-input"
                        @keyup.enter="onSearch" @input="handleInput" enterkeyhint="Search" @focus="handleInputFocus"
                        @blur="handleInputBlur" ref="searchInputRef" />
                    <div class="close-btn flex items-center justify-center pl-10px w-29px" @click="handleClose"
                        v-if="search.length > 0">
                        <img src="@/assets/images/message/close.svg" class="w-full h-full" />
                    </div>
                </div>
                <div class="absolute top-40px z-9999 left-30px max-h-300px overflow-y-auto bg-#1B1D32 w-90% px-12px rounded-18px"
                    v-if="realTimeSearchList.length > 0" ref="realTimeSearchDropdownRef">
                    <div v-for="item in realTimeSearchList" class="h-40px flex items-center"
                        @click="handleRealTimeSearch(item.name)">
                        <div class="flex items-center justify-center w-10px h-10px mr-5px">
                            <img src="@/assets/images/home/search.webp" class="w-full h-full" />
                        </div>
                        <div class="color-#fff flex-1 w-120px">
                            <div class="text-ellipsis overflow-hidden">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div v-if="!isEmpty" class="overflow-y-auto h-90vh!">
                <div class="search-history" v-if="searchHistory.length > 0">
                    <div class="color-#fff text-12px font-900 my-15px flex  justify-between">
                        <div>
                            Search History
                        </div>
                        <div class="w-20px h-20px" @click="handleDeleteHistory">
                            <img src="@/assets/images/message/delete.webp" class="w-full h-full" />
                        </div>
                    </div>
                    <div class="popular-search flex flex-wrap">
                        <div class="popular-search-item mr-5px mb-5px" v-for="(item, index) in searchHistory"
                            @click="handlePopularSearch(item)" :key="index">
                            {{ item }}
                        </div>
                    </div>
                </div>
                <div v-if="popularSearch.length > 0">
                    <div class="color-#fff text-12px font-900 my-15px">
                        Popular
                    </div>
                    <div class="popular-search flex flex-wrap">
                        <div class="popular-search-item-text mr-5px mb-5px" v-for="item in randomList.slice(0, 12)"
                            :key="item.id" @click="handlePopularSearch(item.name)">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <div class="">
                    <div class="color-#fff text-12px font-900 sticky top-0 z-10 w-100% bg-#01031B py-15px">Recommend</div>
                    <div class="recommend-roles overflow-y-auto" ref="recommendContainerRef"
                        :style="{ minHeight: recommendHeight + 'px' }">
                        <!-- 错误状态 -->
                        <div v-if="recommendError" class="flex flex-col items-center justify-center mt-100px">
                            <div class="color-#fff text-12px mb-10px">No network</div>
                            <div @click="handleRetryRecommend" class="retry-btn">Retry</div>
                        </div>
                        <!-- 加载状态 -->
                        <div v-else-if="recommendLoading" class="h-100%">
                            <SkeletonPresets preset="card" :loading="true" :animated="true" />
                        </div>
                        <!-- 正常内容 -->
                        <AppWaterfall v-else-if="recommendRoles.length > 0" :items="recommendRoles" :columns="2" itemKey="id">
                            <template #item="{ item }">
                                <AppCard :info="item" @open-preview="handleOpenPreview" />
                            </template>
                        </AppWaterfall>
                    </div>
                </div>
                
            </div>
            <div class="search-list h-90vh overflow-y-auto mt-20px pb-100px flex-1" v-else ref="searchListContainerRef">
                <div class="flex-1">
                    <AppWaterfall :items="searchList" :columns="2" itemKey="id" v-if="!loading">
                        <template #item="{ item }">
                            <AppCard :info="item" @open-preview="handleOpenPreview" />
                        </template>
                    </AppWaterfall>
                    <SkeletonPresets preset="card" :loading="true" :animated="true" v-else class="h-100vh" />
                </div>
                <div v-if="searchList.length === 0 && !loading">
                    <AppEmpty :imgSrc="noData" :title="t('home.noData')" :description="t('home.noData')" />
                </div>
            </div>

        </appPage>
        <FirstChargePopUp v-model:showPopup="showPopupFirstCharge" url="/" />

    </div>
</template>

<script setup lang="ts">
import FirstChargePopUp from '@/views/home/com/FirstChargePopUp.vue'
import theme from '@/styles/theme'
import { AppPage } from '@/components/layout'
import { AppWaterfall, SkeletonPresets, AppEmpty } from '@/components/display'
import { AppCard } from '@/components/display'
import { useI18n } from 'vue-i18n'
import { useRouter, onBeforeRouteLeave } from 'vue-router'
import { useSearchStore } from '@/stores/seacch'
import { ref, onMounted, onBeforeUnmount, nextTick, computed } from 'vue'
import { storeToRefs } from 'pinia'
import noData from '@/assets/images/message/empty.webp'
import { useIOSKeyboard } from '@/composables/useIOSKeyboard'
import { HomeAPI } from '@/services/home'
import { debounce } from '@/utils/date'
const { t } = useI18n()
const router = useRouter()
const search = ref('')
const isRefresh = ref(false)
const showPopupFirstCharge = ref(false)
const { recommendRoles, searchHistory, popularSearch, searchList, loading, isEmpty, randomList } = storeToRefs(useSearchStore())
// 推荐列表的加载和错误状态
const recommendLoading = ref(false)
const recommendError = ref(false)
// iOS 键盘处理
const { handleInputFocus, handleInputBlur } = useIOSKeyboard()

// 计算剩余高度用于滚动容器
const recommendContainerRef = ref<HTMLElement | null>(null)
const searchListContainerRef = ref<HTMLElement | null>(null)
const realTimeSearchDropdownRef = ref<HTMLElement | null>(null)
const searchBoxRef = ref<HTMLElement | null>(null)
const searchInputRef = ref<HTMLInputElement | null>(null)
const recommendHeight = ref(0)
const searchListHeight = ref(0)
const realTimeSearchList = ref<any[]>([])

const computeRemainingHeight = (el: HTMLElement, extraBottom: number = 0): number => {
    const rect = el.getBoundingClientRect()
    const vh = window.innerHeight
    return Math.max(0, vh - rect.top - extraBottom)
}

const updateHeights = () => {
    if (recommendContainerRef.value) {
        recommendHeight.value = computeRemainingHeight(recommendContainerRef.value, 0)
    }
    if (searchListContainerRef.value) {
        // 与样式中的 pb-100px 对齐，预留底部空间
        searchListHeight.value = computeRemainingHeight(searchListContainerRef.value, 0)
    }
}


/**
 * 处理搜索
 */
const handleSearch = () => {
    router.push({ name: 'Search' })
}

/**
 * 处理实时搜索
 */
const handleRealTimeSearch = (name: string) => {
    search.value = name
    onSearch()
}
/**
 * 处理返回
 */
const handleBack = () => {
    const fromSearchRoute = localStorage.getItem('FromSearchRoute')
    router.push({ path: fromSearchRoute || '/' })
}
/**
 * 处理搜索
 */
const onSearch = () => {
    console.log(12312);

    useSearchStore().setSearchHistory(search.value)
    useSearchStore().setSearchList(search.value)
    searchListHeight.value = window.innerHeight
    // 关闭键盘
    if (searchInputRef.value) {
        searchInputRef.value.blur()
    }
    realTimeSearchList.value = []

}

/**
 * 处理热门搜索
 */

const handlePopularSearch = debounce((name: string) => {
    search.value = name
    // 关闭键盘
    if (searchInputRef.value) {
        searchInputRef.value.blur()
    }
    onSearch()
}, 300)


const handleOpenPreview = () => {
    showPopupFirstCharge.value = true
}

/**
 * 处理输入
 */
const handleInput = debounce(async (e: any) => {

    if (e.target.value.length === 0) {
        useSearchStore().setSearchList(search.value)
        realTimeSearchList.value = []
        return
    }
    const response = await HomeAPI.getRoleList({
        page: 1,
        pageSize: 100,
        keywords: e.target.value
    })
    realTimeSearchList.value = response.data as any || []
}, 300)
/**
 * 刷新
*/
const onRefresh = async () => {
    isRefresh.value = true
    await useSearchStore().getRecommendRoles()
    isRefresh.value = false
}
/**
 * 处理关闭
 */
const handleClose = () => {
    search.value = ''
    useSearchStore().setSearchList(search.value)
    realTimeSearchList.value = []
}

/**
 * 加载推荐列表
 */
const loadRecommendRoles = async () => {
    recommendLoading.value = true
    recommendError.value = false
    try {
        await useSearchStore().getRecommendRoles()
        recommendError.value = false
    } catch (error) {
        console.error('Failed to load recommend roles:', error)
        recommendError.value = true
    } finally {
        recommendLoading.value = false
    }
}

/**
 * 重试加载推荐列表
 */
const handleRetryRecommend = () => {
    loadRecommendRoles()
    useSearchStore().getRandomList()
}

/**
 * 点击外部关闭下拉列表
 */
const handleClickOutside = (event: Event) => {
    const target = event.target as Node
    const dropdownEl = realTimeSearchDropdownRef.value
    const searchBoxEl = searchBoxRef.value

    // 如果下拉列表存在且点击不在下拉列表和搜索框内，则关闭
    if (realTimeSearchList.value.length > 0 && dropdownEl && searchBoxEl) {
        if (!dropdownEl.contains(target) && !searchBoxEl.contains(target)) {
            realTimeSearchList.value = []
        }
    }
}
/**
 * 处理删除历史
 */
const handleDeleteHistory = () => {
    useSearchStore().removeSearchList()
    searchHistory.value = []
}
onMounted(async () => {
    // 加载推荐列表
    loadRecommendRoles()
    // await useSearchStore().getPopularSearch()
    // await useSearchStore().getSearchHistory()
    // await useSearchStore().getRandomList()
    await nextTick()
    updateHeights()
    window.addEventListener('resize', updateHeights)
    // // 监听点击事件，用于关闭下拉列表
    // document.addEventListener('click', handleClickOutside, true)
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', updateHeights)
    document.removeEventListener('click', handleClickOutside, true)
})

// 离开页面时清空输入框并重置搜索列表
onBeforeRouteLeave(() => {
    loadRecommendRoles()
    useSearchStore().getRandomList()
    search.value = ''
    useSearchStore().setSearchList('')
    realTimeSearchList.value = []
})
window.addEventListener('paymentResult', function () {
    showPopupFirstCharge.value = false
});
</script>

<style scoped lang="scss">
.search-box {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    height: 35px;
    border-radius: 18px;
    background-color: v-bind('theme.colors.backgroundQuinary');

    .search-input {
        background-color: transparent;
        border: none;
        outline: none;
        font-size: 14px;
        color: v-bind('theme.colors.textPrimary');
        font-size: 12px;
        line-height: 14px;
    }
}

.popular-search {
    align-items: flex-start; // 让每个元素根据自身内容决定高度，不拉伸对齐
    // max-height: 50px; // 限制只显示两排
    // overflow: hidden; // 隐藏超出部分

    .popular-search-item {
        background-color: v-bind('theme.colors.backgroundQuinary');
        font-weight: 500;
        font-size: 10px;
        line-height: 12px;
        color: #FFFFFF;
        padding: 2px 8px;
        border-radius: 9px;
        max-width: 100px;
        height: auto; // 自适应高度
        max-height: 28px; // 最大高度：2行(12px*2) + 上下padding(2px*2) = 28px
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        word-break: break-word;
    }

    .popular-search-item-text {
        background-color: v-bind('theme.colors.backgroundQuinary');
        font-weight: 500;
        font-size: 10px;
        line-height: 12px;
        color: #FFFFFF;
        padding: 2px 8px;
        border-radius: 9px;
        max-width: 150px;
        height: auto; // 自适应高度
        max-height: 28px; // 最大高度：2行(12px*2) + 上下padding(2px*2) = 28px
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        word-break: break-word;
    }
}

.retry-btn {
    font-family: Avenir, Avenir;
    font-weight: 500;
    font-size: 14px;
    color: #7284F7;
    cursor: pointer;
    text-align: center;
    margin-top: 10px;
    border-radius: 20px;
    border: 1px solid #7284F7;
    width: 100px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;

    &:active {
        opacity: 0.7;
        transform: scale(0.98);
    }
}
</style>